import axios from '@fs/zion-axios'
import { i18n } from '@fs/zion-locale'
import { checkAsianChar } from '../../../shared/helpers/name_formatting'

const serviceBase = '/service/discovery/allaboutme'

export const getTileData = async ({ countryCode, year }) => {
  const headers = {
    'Accept-Language': i18n.language,
  }
  return axios.get(`${serviceBase}/tile/region/${countryCode}/year/${year}`, { headers })
}

export const postBirthDate = async ({ personId, birthDate }) => {
  return axios.post(`/service/discovery/common/tree/birthdate/${personId}?birthDate=${birthDate}`)
}

export const getVariantData = async ({ nameArray, firstName }) => {
  const createFirstNameUrl = (variantName) => `/service/homelands/core/name?text=${variantName}&type=FIRST&format=html`
  const createLastNameUrl = (variantName) => `/service/homelands/core/name?text=${variantName}&type=LAST&format=html`

  if (firstName) {
    return axios.all(nameArray.map((vari) => axios.get(createFirstNameUrl(vari.name))))
  }

  return axios.all(nameArray.map((vari) => axios.get(createLastNameUrl(vari.name))))
}

export const formatTileContentData = (tileData) => {
  const isFirst = tileData.id !== 27
  let name = ''
  const firstName = tileData?.parsedNames?.firstName?.name
  const middleNames = tileData?.parsedNames?.middleNames
    ? `${tileData?.parsedNames?.middleNames?.map((obj) => obj.name).join(' ')} `
    : ''
  const lastName = tileData?.parsedNames?.lastName?.name
  const isAsian = checkAsianChar(firstName)
  if (isFirst) {
    name = firstName ?? ''
    // Asian names are provided with the last name as the first name
    if (isAsian) name = lastName
  } else {
    name = lastName ?? middleNames
    if (isAsian) name = firstName
  }

  return {
    type: tileData.type,
    supportedTileId: tileData.supportedTileId,
    homelandId: tileData.homelandId,
    year: tileData.year,
    countryCode: tileData.region,
    tileId: tileData.id,
    nameArgs: { name, isFirst },
  }
}

export const getTileContentData = async ({
  homelandId,
  supportedTileId,
  type,
  countryCode,
  year,
  tileId,
  nameArgs: { name, isFirst },
}) => {
  const firstNameHeatmapURL = `${serviceBase}/tile/name/count/first/name/${name}/region/${countryCode}`
  const lastNameHeatmapURL = `${serviceBase}/tile/name/count/last/name/${name}/region/${countryCode}`
  const generalTileDataURL = `${serviceBase}/tile/id/${tileId}/region/${countryCode}/year/${year}`
  // hotfix until the backend can investigate
  const baseballTileDataURL = `${serviceBase}/tile/id/${tileId}/region/${
    countryCode === 'pr' ? 'us' : countryCode
  }/year/${year}`
  const surnameCountURL = `${serviceBase}/treesurnamecount/${name}`
  const firstNameMeaningURL = `/service/homelands/core/name?text=${name}&type=FIRST&format=html`
  const lastNameMeaningURL = `/service/homelands/core/name?text=${name}&type=LAST&format=html`
  let urlToUse = ''
  if (tileId === 4) {
    urlToUse = isFirst ? firstNameMeaningURL : lastNameMeaningURL
  } else if (tileId === 28) {
    urlToUse = isFirst ? firstNameHeatmapURL : lastNameHeatmapURL
  } else if (tileId === 27 && name) {
    urlToUse = surnameCountURL
  } else if (tileId === 4) {
    urlToUse = firstNameMeaningURL
  } else if (tileId === 17) {
    urlToUse = baseballTileDataURL
  } else if (type === 'quiz') {
    return axios.get(`/service/homelands/core/quiz/${homelandId}/generate?year=${year}`).then((res) => {
      function formatAnswers({ answer, choices }) {
        const answerIndex = choices.indexOf(answer)
        choices.splice(answerIndex, 1)
        choices.unshift(answer)
        return choices.join('|')
      }
      res.data = [
        {
          id: res.data.quiz.id,
          year: res.data.year,
          text: res.data.quiz.question,
          quizType: '',
          answers: formatAnswers(res.data),
          answerText: res.data.answer,
          text1: res.data.body[0],
          text2: res.data.body[1],
          text3: res.data.body[2],
          text4: res.data.body[3],
          image: '',
          language: res.data.quiz.language,
          region: res.data.quiz.region,
        },
      ]

      return res
    })
  } else if (type === 'fact' || type === 'event') {
    return axios.get(`/service/homelands/core/item?tag=aam.${supportedTileId}&startYear=${year}`).then((res) => {
      const data = res.data.items[0]
      if (data) {
        res.data = [
          {
            id: data.id,
            year: data.startYear,
            startYear: data.startYear,
            endYear: data.endYear,
            tileType: data.type,
            localeOnly: data.region,
            languageOnly: data.availableLanguages[0],
            categoryId: 0,
            icon: '',
            textTitle: data.title,
            textHeadline: data.body[0],
            textAdditional: data.body[1],
            image: '',
            category: data.category,
            subcategory: data.subcategory,
          },
        ]
      } else {
        res.data = undefined
      }
      return res
    })
  } else if (type === 'lineChart') {
    return axios.get(`/service/homelands/core/item?tag=aam.${supportedTileId}&count=200`).then((res) => {
      res.data = res.data.items
        .map((item) => ({
          id: item.id,
          year: item.startYear,
          price: item.numericValue,
          tileType: item.type,
          localeOnly: item.region,
          languageOnly: item.language,
          categoryId: 0,
          icon: '',
          textTitle: item.title,
          textHeadline: item.body[0],
          category: item.category,
          subcategory: item.subcategory,
        }))
        .filter((item) => item.localeOnly === countryCode)
      return res
    })
  } else {
    urlToUse = generalTileDataURL
  }

  return axios.get(urlToUse)
}
